export const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload || payload.length === 0) return null;

  // Filter out the gap segments from the tooltip
  const filteredPayload = payload.filter(
    (entry: any) => !entry.dataKey.includes("gap")
  );

  return (
    <div className="bg-white p-3 shadow-lg rounded-lg border border-gray-100">
      <div className="text-[13px] font-medium text-gray-900 mb-2">{label}</div>
      <div className="space-y-1.5">
        {filteredPayload.map((entry: any) => (
          <div
            key={entry.name}
            className="flex items-center justify-between gap-4 text-[13px]"
          >
            <div className="flex items-center gap-2">
              <div
                className="w-2 h-2 rounded-full"
                style={{
                  backgroundColor: entry.color || "#bce3ff",
                }}
              />
              <span className="text-gray-500 capitalize">{entry.name}</span>
            </div>
            <span className="font-medium text-gray-900">{entry.value}</span>
          </div>
        ))}
        <div className="pt-1.5 mt-1 border-t border-gray-100">
          <div className="flex items-center justify-between gap-4 text-[13px]">
            <span className="font-medium text-gray-900">Total</span>
            <span className="font-medium text-primary-600">
              {filteredPayload.reduce(
                (sum: number, entry: any) => sum + entry.value,
                0
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
